module.exports = __webpack_public_path__ + "img/tag.9aa6ddae.svg";